export const carburant2CO2 = {
  gazole: 3.12, // Gazole
  electricite: 0, // Électricité (dépend de la source, mais supposons zéro pour simplification)
  hydrogene: 0, // Hydrogène (dépend de la production, mais supposons zéro pour simplification)
  gaz_naturel: 2.75, // Gaz naturel
  sans_plomb_95: 2.31, // Sans Plomb 95
  sans_plomb_98: 2.29, // Sans Plomb 98
};
